export default "__VITE_ASSET__e5d6d59d__"